import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, deleteData, getmediapartnersType } from '../../services/mediaPartnersServices';
import { Button, Modal, Form } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DataTable from 'react-data-table-component';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import { validateFile} from '../../utils/validators';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';
import { isQuillContentEmpty } from '../../utils/common';

const modules = {
  toolbar: [
    // Font family and size
    [{ 'font': [] }, { 'size': ['small', false, 'large', 'huge'] }],

    // Headings
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    // Text styles
    ['bold', 'italic', 'underline', 'strike'],

    // Subscript / Superscript
    [{ 'script': 'sub' }, { 'script': 'super' }],

    // Blockquote and code block
    ['blockquote', 'code-block'],

    // Color and background
    [{ 'color': [] }, { 'background': [] }],

    // Text alignment and direction (RTL)
    [{ 'align': [] }, { 'direction': 'rtl' }],

    // Ordered / bullet list
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],

    // Indent and outdent
    [{ 'indent': '-1' }, { 'indent': '+1' }],

      ['link'],

    // Clear formatting
    ['clean']
  ]
};
  
const formats = [
  'font', 'size',
  'header',
  'bold', 'italic', 'underline', 'strike',
  'script',
  'blockquote', 'code-block',
  'color', 'background',
  'align', 'direction',
  'list', 'bullet', 'indent',
  'link', 'image', 'video'
];

const Mediapartners = () => {
  const [data, setData] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    id: null,
    uploadedfile: null, 
    alt_title: '', 
    description: '',
    order_media: '',
    media_link: '',
    media_type: ''  
  });
  const [modalType, setModalType] = useState(''); // 'add' or 'edit'
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setselectedData] = useState(null);
  const [mediapartnersType, setmediapartnersType] = useState([]);
  
  const [searchText, setSearchText] = useState('');
  // const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  // Fetch data from API
      const fetchData = useCallback(async () => {
        setLoading(true);
        try {
        const response = await getData();
        setData(response);
        }
        catch (error) { 
          console.error('Error fetching data:', error);
        }
        finally {
          setTimeout(() => {
            setLoading(false);
          }, 500);
        }
      }, []);
  
      useEffect(() => {
        fetchData();
      }, [fetchData]);
  
  useEffect(() => {
      const fetchmediapartnersType = async () => {
        try {
          const data = await getmediapartnersType(); // Fetch data from the service
          setmediapartnersType(data); // Set the types in state
        } catch (error) {
          console.error('Error fetching media partners type:', error);
        }
      };
      fetchmediapartnersType();
    }, []);
 
    // Validate form data
      const validateForm = () => {
      const newErrors = {};
      if (!formData.title) newErrors.title = "Title  is required";
      if (!formData.alt_title) newErrors.alt_title = "Alt Title  is required";
      if (!formData.order_media) newErrors.order_media = "Order is required";
      if (!formData.media_link) newErrors.media_link = "Media link is required";
      if (!formData.media_type) newErrors.media_type = "Type is required";
      if (!formData.uploadedfile && formData.uploadedfile === null) {
      if (!errors.uploadedfile) newErrors.uploadedfile = " Picture is required";}
      if ( isQuillContentEmpty(formData.description.trim())) newErrors.description = "Long Description is required";
      setErrors((prev) => ({ ...prev, ...newErrors }));
      return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);  
    }

    const handleChange = async (e) => {
      try{
          const { name, value, files } = e.target;
          const file = files?.[0]
            // Create a copy of the current form data
            let updatedData = { ...formData };
            let updatedErrors = { ...errors };
            if (file) {
                const fileType = file.type.includes("image") ? "img" : "pdf";
                const isValid = await validateFile(file, setErrors,name,fileType);
                if (isValid) {
                  updatedData[name] = file;
                  updatedErrors[name] = '';
                }
                else{
                  return ; // Don't update if invalid
                }
          } 
            else{
            updatedData[name] = value;
            if (value) {
            updatedErrors[name] = ''; // Clear error if corrected
          }
          // Field-specific validations
        if (name === 'order_media') {
            if (value.trim() === '') {
            updatedErrors[name] = "Order is required";
          }
          else if (!/^[0-9]+$/.test(value)) {
            updatedErrors[name] = "Order must be a number";
          } else if (Number(value) === 0) {
            updatedErrors[name] = "Order value must be greater than zero";
          } else {
            const isDuplicate = data.some((item) => {
              if (item.id === editingId) return false; // skip current editing item
              return item?.order_media === Number(value);
            });
            if (isDuplicate) {
              updatedErrors[name] = "Order already exists";
            }
          }
        }
        }
          setFormData(updatedData);
          setErrors(updatedErrors);
        }
        catch (error) {
        console.error("Error in handleChange:", error);
      }
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      if (!validateForm()) {
        return
      }
      try{
      const form = new FormData();
      form.append('id', formData.id);
      form.append('title', formData.title);
      form.append('alt_title', formData.alt_title);
      form.append('description', formData.description);
      form.append('order_media', formData.order_media);
      form.append('media_link', formData.media_link);
      form.append('media_type', formData.media_type);
      form.append('uploadedfile', formData.uploadedfile);
  
      if (modalType === 'add') {
        const result = await addData(form);
        if (result.status === 200) {
          fetchData();
          setShowModal(false);
          toast.success("Added Successfully!", {position: 'top-right', autoClose: 3000});
        } else {
          toast.error(result.message ||"Failed to Added data. Please try again.", {position: 'top-right',autoClose: 3000});
        }
      } else if (modalType === 'edit') {
        const result = await updateData(form);
        if (result.status === 200) {
          fetchData();
          setShowModal(false);
          toast.success("Updated Successfully!", {position: 'top-right', autoClose: 3000,});
        } else {
          toast.error(result.message ||"Failed to update data. Please try again.", {position: 'top-right',autoClose: 3000});
        }
      }
    }
    catch (error) {
      console.error("Error in handleChange:", error);
    }
    };

    const handleDelete = async () => {
      try{
      if (selectedData) {
        const result = await deleteData(selectedData.id);
        if (result.status === 200) {
          fetchData();
          setShowDeleteConfirmModal(false);
          toast.success("Deleted Successfully!", { position: 'top-right', autoClose: 3000,});
        } else {
          toast.error(result.message ||"Failed to Delete data. Please try again.", {position: 'top-right',});
        }
      }
    }
    catch (error) {
          console.error('Error deleting data:', error);
          }
    };
  
    
  // Handle change for Quill editor
  const handledescriptionChange = (value) => {
    setErrors((prev) => ({ ...prev, description: isQuillContentEmpty(value) ? 'Description is required' : '' }));
    setFormData((prev) => ({ ...prev, description: value }));
  };
  
  const openModal = (type, data = { 
    id: null,
    uploadedfile: null, // File input should be reset
    title: '',
    alt_title: '',
    description: '',
    order_media: '',
    media_link: '',
    media_type: ''
    
   }) => {
    setModalType(type);
    setFormData(data);
    setEditingId(data?.id);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const openDeleteConfirmModal = (data) => {
    setselectedData(data);
    setShowDeleteConfirmModal(true);
  };

  const closeDeleteConfirmModal = () => {
    setShowDeleteConfirmModal(false);
    setselectedData(null);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

   // Memoized filtered data based on search query
    const filteredData = useMemo(() => {
        const filtered = data.filter(
          (data) =>
          data.title.toLowerCase().includes(searchText.toLowerCase()) ||
          data.alt_title.toLowerCase().includes(searchText.toLowerCase()) 
        );
        const sortedData = [...filtered].sort((a, b) => a.order_media - b.order_media);
        return sortedData;
      }, [data, searchText]);
    

  const columns = [
    {
      name: 'Order',
      selector: (row) => (<span title={row.order_media}>{row.order_media}</span>),
      sortable: true,
    },
    {
        name: 'Type',
        selector: (row) => {
          const matched = mediapartnersType.find(opt => opt.media_type_value === row.media_type);
          const label = matched ? matched.media_type : row.media_type_value;
          return <span title={label}>{label}</span>;
        },
        sortable: true,
    },
    {
        name: 'Title',
        selector: (row) => (<span title={row.title}>{row.title}</span>),
        sortable: true,
    },
    {
    name: 'Picture',
    selector: (row) => <img src={row.pic} width="100" alt={row.alt_title} 
    style={{ width: '60px', height: '40px', objectFit: 'cover' }}
    crossOrigin="anonymous" 
    />,
    sortable: false,
    },
    {
      name: 'Actions',
      cell: (row) => (
                <div>
                  <Button
                    className="me-2"
                    variant="warning"
                    size="sm"
                    onClick={() => openModal('edit', {
                      id: row.id,
                      uploadedfile: row.pic, // File input should be reset
                      title: row.title, 
                      alt_title: row.alt_title, 
                      description: row.description, 
                      order_media: row.order_media,
                      media_link: row.media_link, 
                      media_type: row.media_type,      
                    })}
                  >
                    Edit
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => openDeleteConfirmModal(row)}
                  >
                    Delete
                  </Button>
                </div>
              ),
    },
  ];


  useEffect(() => {
        const tooltipMap = {
          'ql-bold': 'Bold',
          'ql-italic': 'Italic',
          'ql-underline': 'Underline',
          'ql-strike': 'Strikethrough',
          'ql-script[value="sub"]': 'Subscript',
          'ql-script[value="super"]': 'Superscript',
          'ql-blockquote': 'Blockquote',
          'ql-code-block': 'Code Block',
          'ql-color': 'Text Color',
          'ql-background': 'Background Color',
          'ql-align': 'Align',
          'ql-direction': 'Text Direction',
          'ql-list[value="ordered"]': 'Ordered List',
          'ql-list[value="bullet"]': 'Bullet List',
          'ql-indent[value="-1"]': 'Outdent',
          'ql-indent[value="+1"]': 'Indent',
          'ql-link': 'Insert Link',
          'ql-clean': 'Clear Formatting',
        };
  
      const setTooltips = () => {
        Object.entries(tooltipMap).forEach(([selector, title]) => {
          const el = document.querySelector(`.ql-toolbar .ql-formats .${selector}`);
          if (el && !el.title) {
            el.setAttribute('title', title);
          }
        });
      };
  
      const observer = new MutationObserver((mutations, obs) => {
        const toolbarReady = document.querySelector('.ql-toolbar');
        if (toolbarReady) {
          setTooltips();
          obs.disconnect(); // Stop observing once done
        }
      });
  
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
  
    return () => observer.disconnect() // Clean up on unmount
    }, []);

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>Other Pages <b>/ Media Partners</b></p>
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>
                Add
              </button>
            </div>
          </div>
          {/* <h1 className="title_slider">
            Media Partners
            <Button className="btn btn-primary mb-3 form-label-custom" onClick={() => openModal('add')}>
              Add
            </Button>
          </h1> */}

          {/* Data Table for data */}
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
            noRowsPerPage: true,
            }}
            // onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal show={showModal} className="modal-lg" onHide={closeModal} backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title className='fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleSubmit}>
                <div className='row'>
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Order <small className='text-danger'>*</small></Form.Label>
                  <Form.Control
                    type="number"
                    name="order_media"
                    value={formData.order_media}
                    onChange={handleChange}
                    isInvalid = {!!errors.order_media}
                  />
                <Form.Control.Feedback type="invalid">{errors.order_media}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="col-md-6 mb-3">
                <Form.Label className='form-label-custom'>Type <small className='text-danger'>*</small></Form.Label>
                 <Form.Control className="mb-3 form-select" as="select" name="media_type" value={formData.media_type} onChange={handleChange}  isInvalid = {!!errors.media_type}>
                    <option value="">Select Type</option>
                    {mediapartnersType.map((mediapartners) => (
                        <option key={mediapartners.media_type_value} value={mediapartners.media_type_value}>
                        {mediapartners.media_type}
                        </option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">{errors.media_type}</Form.Control.Feedback>
                  
                </Form.Group>

                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Title <small className='text-danger'>*</small></Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    isInvalid = {!!errors.title}
                  />
                <Form.Control.Feedback type="invalid">{errors.title}</Form.Control.Feedback>
                </Form.Group>
                
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Alt Title <small className='text-danger'>*</small></Form.Label>
                  <Form.Control
                    type="text"
                    name="alt_title"
                    value={formData.alt_title}
                    onChange={handleChange}
                    isInvalid = {!!errors.alt_title}
                  />
                <Form.Control.Feedback type="invalid">{errors.alt_title}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Media Link <small className='text-danger'>*</small></Form.Label>
                  <Form.Control
                    type="text"
                    name="media_link"
                    value={formData.media_link}
                    onChange={handleChange}
                    isInvalid = {!!errors.media_link}
                  />
                <Form.Control.Feedback type="invalid">{errors.media_link}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>
                  Picture <small className='text-danger'>*</small> <small className="text-primary"> (Dimension:200x63 | Size:10kb-30kb)</small>
                  </Form.Label>
                  <Form.Control
                    type="file"
                    name="uploadedfile"
                    onChange={handleChange}
                    isInvalid = {!!errors.uploadedfile}
                    accept="image/*"
                  />
                <Form.Control.Feedback type="invalid">{errors.uploadedfile}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3">
                <Form.Label className='form-label-custom'>Long Description <small className='text-danger'>*</small></Form.Label>
                <ReactQuill
                    value={formData.description}
                    onChange={handledescriptionChange}
                    theme="snow"
                    modules={modules}
                    formats={formats}
                    placeholder="Enter description"
                    className={`react-quill-editor ${errors.description ? 'border border border-1 border-danger rounded' : ''}`}
                />
                  {errors.description && (
                      <div className="invalid-feedback d-block">
                        {errors.description}
                      </div>
                    )}
                </Form.Group>
                </div>

                <Modal.Footer className='border-0'>
                  <Button variant="secondary" onClick={closeModal}>
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit">
                    {modalType === 'add' ? 'Add' : 'Save'}
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal.Body>
          </Modal>

          {/* Delete Confirmation Modal */}
          <Modal show={showDeleteConfirmModal} onHide={closeDeleteConfirmModal}>
            <Modal.Header closeButton>
              <Modal.Title>Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this row?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={closeDeleteConfirmModal}>
                Cancel
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                Yes, Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
        </div>
      )}
      </div>
    </div>
  );
};

export default Mediapartners;